import { tuple } from '@bydesign-ui/utils';
export var TriggerType = tuple('reset', 'change', 'blur', 'manual', 'force');
export var TriggerTypeMap = TriggerType.reduce(function (map, item, index) {
  map[item] = index;
  return map;
}, {});